const applicationCenterIndex = () => import('@/pages/applicationCenter/index/index.vue')
const applicationCenterDetail = () => import('@/pages/applicationCenter/detail/detail.vue')

export default [
  {
    path: '/applicationCenter/index/:token/:sisscloudtokenid?/:otherData?',
    component: applicationCenterIndex,
    name: 'applicationCenterIndex',
    meta: {
      title: '应用中心'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/applicationCenter/detail/:token/:sisscloudtokenid?/:otherData?',
    component: applicationCenterDetail,
    name: 'applicationCenterDetail',
    meta: {
      title: '应用中心-详情'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  }
]
